import{getCentury}from"./getCentury";export var endOfCentury=function(a){return new Date(getCentury(a)+99,11,1,23,59,59,999)};
//# sourceMappingURL=endOfCentury.js.map